import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputTextSF from '../../widgets/form/InputTextSF'

const EmailUpdateUI = ({context, messageList, successMsg, errorList,
    submitted, onSubmit, onCancel, setErrorList,
    email, emailError, onEmailChange, setEmailError}) =>
  <CardUI context={context}>
    <FormSF context={context}
      messageList={messageList} buttonMessageKey='c_update' cancelMessageKey='c_cancel'
      successMsg={successMsg} errorList={errorList}
      busy={submitted} onSubmit={onSubmit} onCancel={onCancel} setErrorList={setErrorList}
    >
      <InputTextSF type='text' name='email' required={true} maxLength={64}
        messageList={messageList} labelKey='c_email'
        value={email} error={emailError} onChange={onEmailChange} setError={setEmailError}
        autoFocus={true}
      />
    </FormSF>
  </CardUI>

export default EmailUpdateUI
